<template>
<section>
	<ul class="flex wrap align-center justify-center">
		<li v-for="(logo, index) in logos" :key="index">
			<img :src="`${assetUrl}img${logo.url}`" :width="logo.width" :height="logo.height">
		</li>
	</ul>
</section>
</template>

<script>
export default {
	props: {
		logos: {
			type: Array,
			default: () => ([])
		}
	},
	computed: {
		assetUrl () {
			return process.env.VUE_APP_RELATIVE_URL || '/';
		}
	}
};
</script>

<style lang="scss" scoped>
	@use '../../assets/scss/logoBar.scss';
</style>
